//@ts-ignore
import { PablockSDK } from 'pablock-sdk';

import {
  pablockMetaTransaction,
  pablockMultiSignFactory,
  pablockNft,
  pablockNotarization,
  pablockTokenAddress,
  rpcProvider,
  sdkApi,
  sdkEnv,
} from '../imports/constants';

const sdk = new PablockSDK({
  apiKey: sdkApi,
  config: {
    env: sdkEnv,
    debugMode: true,
    rpcProvider,
    pablockContracts: {
      PABLOCK_TOKEN_ADDRESS: pablockTokenAddress,
      PABLOCK_META_TRANSACTION: pablockMetaTransaction,
      PABLOCK_NOTARIZATION: pablockNotarization,
      PABLOCK_NFT: pablockNft,
      PABLOCK_MULTISIGN_FACTORY: pablockMultiSignFactory,
    },
  },
});

export default sdk;
